// extracted by mini-css-extract-plugin
export default {"whatsAppButton":"WhatsAppChatButton_whatsAppButton__zSYIW"};